module.exports = __webpack_public_path__ + "assets/5154771279fa8fe15bf67399a6345492.svg";